import { Component, ElementRef, OnInit } from '@angular/core';

@Component({
	selector: 'app-banking-staff-dashboard-wrapper',
	templateUrl: './banking-staff-dashboard-wrapper.component.html',
	styleUrls: ['./banking-staff-dashboard-wrapper.component.scss']
})
export class BankingStaffDashboardWrapperComponent implements OnInit {
	public loadMfe = false;

	constructor(private elRef: ElementRef) {}

	public ngOnInit(): void {
		this.preventUnmount();
	}

	public preventUnmount() {
		const mfeNode = this.elRef.nativeElement.querySelector('mfe-loader');

		if (mfeNode) {
			mfeNode.preventUnmount = true;
		}

		// validate if the mfeNode has childNodes in loop until it has childNodes to set loadMfe to true
		const interval = setInterval(() => {
			if (mfeNode?.childNodes?.length ?? 0) {
				this.loadMfe = true;
				clearInterval(interval);
			}
		}, 100);
	}
}
